"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CameraAndScreenCount = require("./CameraAndScreenCount");
Object.keys(_CameraAndScreenCount).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CameraAndScreenCount[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CameraAndScreenCount[key];
    }
  });
});